import React from "react";
import SkipLinks from "../../components/SkipLinks/SkipLinks";
import Navbar from "../../components/Navbar/Navbar";
import AboutContent from "../../components/About/AboutContent";
import ProjectComponent from "../../components/Projects/ProjectComponent";
import styles from "./Home.module.css";
export default function Home() {
	return (
		<>
			<SkipLinks />
			<Navbar />
			<main id="main-content" className={styles.container}>
				<AboutContent />
				<ProjectComponent />
			</main>
		</>
	);
}
